
import { Component, Vue, Watch } from 'vue-property-decorator'
import ItemModal from '../../modules/ItemModal.vue'
import CheckoutModal from '../../modules/order/CheckoutModal.vue'
import Item from '../../modules/Item.vue'
import CategoryHeader from '../../modules/headers/CategoryHeader.vue'
import LoginModal from '@/modules/user/LoginModal.vue'
import RegisterModal from '@/modules/user/RegisterModal.vue'
import Categories from '@/components/Categories.vue'
import PriceFilter from '@/components/PriceFilter.vue'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import axios from 'axios'
import { CategoriesStore } from '@/store/stores/CategoriesStore'
import { ItemsStore } from '@/store/stores/ItemsStore'
import createApi from '@/plugins/api'
import eventBus from '@/plugins/eventBus'

@Component({
  components: {
    ItemModal,
    CheckoutModal,
    Item,
    CategoryHeader,
    LoginModal,
    RegisterModal,
    Categories,
    PriceFilter,
  },
})
export default class catalog extends Vue {
  envConfigurations: any = envConfiguration
  categories: CategoriesStore = CategoriesStore.getInstance()
  items: ItemsStore = ItemsStore.getInstance()

  priceRange: any = {
    minValue: 1,
    maxValue: 9999,
  }

  priceRangeUpdated(range) {
    this.priceRange = range
  }
  sectorId = ''

  sectors = [
    {
      id: 1,
      name: 'sektor1',
    },
    {
      id: 2,
      name: 'sektor2',
    },
    {
      id: 3,
      name: 'sektor3',
    },
    {
      id: 4,
      name: 'sektor4',
    },
  ]

  selectSector(id) {
    this.sectorId = id
    axios.defaults.headers.common['Sector-ID'] = String(this.sectorId)
    eventBus.$emit('sector', this.sectorId)
    this.categories.loadData(Number(this.sectorId))
  }
}
